import { render } from "./TongJi.vue?vue&type=template&id=2ebbcf2e&scoped=true"
import script from "./TongJi.vue?vue&type=script&lang=js"
export * from "./TongJi.vue?vue&type=script&lang=js"

import "./TongJi.vue?vue&type=style&index=0&id=2ebbcf2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebbcf2e"]])

export default __exports__